module.exports = __webpack_public_path__ + "img/mainPic.ed943341.png";